import config from './config-yongle'

export default config
